import {Injectable} from '@angular/core'
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import {ServiceProviderHub} from '@generated-backend-types';
import EventCalendarMonthContainer = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Calendar.Month.EventCalendarMonthContainer;

@Injectable({providedIn: 'root'})
export class EventCalendarMonthService extends BaseApiEndpointService<EventCalendarMonthContainer> {
  protected override endpoint = '/event-calendar/month';

  public modelToMultiSelectItem(m: EventCalendarMonthContainer): ListItem & { model: EventCalendarMonthContainer } {
    return {
      id: m.id,
      text: m.id,
      isDisabled: false,
      model: m,
    }
  }
}
